import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';

export const useStyles = makeStyles(() => ({
  step: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 24,
    width: 24,
    backgroundColor: '#ff8c691a',
    borderRadius: '50%',
    fontWeight: 700,
    fontSize: 14,
    color: '#FF8C69',
    '&:not(:last-child)': {
      marginRight: 8,
      '.rtl &': {
        marginRight: 0,
        marginLeft: 4,
      },
    },
  },
  activeStep: {
    backgroundColor: '#FF8C69',
    color: '#fff',
  },
}));

export const Step = ({ value, isActiveStep }) => {
  const classes = useStyles();
  return (
    <span className={cx(classes.step, { [classes.activeStep]: isActiveStep })}>
      {value}
    </span>
  );
};

Step.propTypes = {
  value: PropTypes.number.isRequired,
  isActiveStep: PropTypes.bool.isRequired,
};